import React, { useCallback } from 'react';
import { Space, Switch } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setAutoSortEnabled } from '@store/noc/base/actions';
import { ToggleText, Header } from '@components/summary-panel/SummaryContainer/Options/styled';
import { autoSortEnabledSelector } from '@store/noc/base/selectors';

function AutoSort() {
  const dispatch = useDispatch();
  const isAutoSortEnabled = useSelector(autoSortEnabledSelector);

  const handleToggleCheck = useCallback(
    (checked) => {
      dispatch(setAutoSortEnabled(checked));
    },
    [dispatch],
  );

  return (
    <Space direction="vertical">
      <Header>NOC</Header>
      <div>
        <Switch checked={isAutoSortEnabled} onChange={handleToggleCheck} />
        <ToggleText>Auto Sort</ToggleText>
      </div>
    </Space>
  );
}

export default AutoSort;
